import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {AdtaDeviceOverviewContext} from "../context/AdtaDeviceOverviewContext";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForConfig, INSTALLATION_TYPES, isValidEntry, PATTERNS
} from "../../../util/Validations";
import {ADTA_ASSET_TYPE} from "../../../util/Constants";

const AddAdtaSorterConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);

    // Visual controls
    const {open, setOpen} = props
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)

    // Values
    const [locations, setLocations] = useState("")
    const [type, setType] = useState("")
    const [bayId, setBayId] = useState("")

    // Error
    const [locationsErr, setLocationsErr] = useState(false)
    const [typeErr, setTypeErr] = useState(false)
    const [bayIdErr, setBayIdErr] = useState(false)

    const onCloseModal = () => {
        setShow(false);
        setOpen(false)
        resetInputState();
    }

    const sorterConfig = {
        bayId: bayId,
        installation: {
            type: type,
            locations: locations
        }
    }

    const sorterConfigMap = {}
    viewModel.sorterConfig[mac].forEach((value) => {
        sorterConfigMap[value.bayId] = {
            type: value.type,
            locations: value.locations.join(';')
        };
    })

    const onClickConfirm = (sorterConfig, mac) => {
        if (checkModalValidationsForConfig(sorterConfig, mac, ADTA_ASSET_TYPE)) {
            setConfigData(sorterConfig, mac);
            setOpen(false)
            resetInputState();
            setShow(false);
        } else {
            setShow(true)
        }
    }

    function resetInputState() {
        setBayId("");
        setBayIdErr(false);
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    const resetConfigDetails = () => {
        setType("");
        setLocations("");
    }

    const resetConfigErrorDetails = () => {
        setTypeErr(false);
        setLocationsErr(false);
    }

    const prefill = (bayId) => {
        if (sorterConfigMap.hasOwnProperty(bayId)) {
            setEdit(true);
            resetConfigErrorDetails();
            setLocations(sorterConfigMap[bayId].locations);
            setType(sorterConfigMap[bayId].type);
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    const setConfigData = (sorterConfig, mac) => {
        console.log("sorterConfig:",sorterConfig);
        sorterConfig.installation.locations = sorterConfig.installation.locations
            .replace(/\s/g, '').split(';').filter(Boolean);
        dispatch({type: 'ADD_CONFIG_DATA', data: {dispatcher: dispatch, sorterConfig: sorterConfig, mac: mac}})
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "config.addupdate"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> <FormattedMessage id="modal.addheading"
                                              defaultMessage="To edit an existing configuration, enter the Bay Id."/>
                        </b>
                        <br/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.bayId" defaultMessage="Bay ID"/>
                        </Text>
                        <Input id="bay-id-input"
                               value={bayId}
                               onChange={setBayId}
                               onBlur={() => {
                                   setBayIdErr(!isValidEntry(bayId, PATTERNS.BAY_ID))
                                   prefill(bayId);
                               }}
                               error={bayIdErr}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.installationtype"
                                              defaultMessage="Installation Type"/>
                        </Text>
                        <Input id="type-input"
                               value={type}
                               onChange={setType}
                               onBlur={() => {
                                   setTypeErr(!INSTALLATION_TYPES.includes(type) && type !== '')
                               }}
                               error={typeErr}
                               helperText={"Must be one of: aisle, miss, cluster, column, ov"}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.location"
                                              defaultMessage="Locations"/>
                        </Text>
                        <Input id="location-input"
                               value={locations}
                               onChange={setLocations}
                               onBlur={() => {setLocationsErr(!isValidEntry(locations, PATTERNS.LOCATION))}}
                               error={locationsErr}
                               helperText={"Separate multiple aisles by semicolon - e.g.: J,1;J,2;J,3"}/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForConfig(sorterConfig, mac, ADTA_ASSET_TYPE) &&
                            show &&
                            <Alert type="warning"
                                   size="small">
                                <FormattedMessage id="alert.missingfields"
                                                  defaultMessage="Please enter all fields in correct format!"/>
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(sorterConfig, mac)}>
                            { edit ? <FormattedMessage id="modal.confirmUpdate" defaultMessage="Confirm update"/>
                                : <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddAdtaSorterConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/modal/AddAdtaSorterConfigurationModal.js